import { ReactElement, useMemo, useState } from "react";
import { FilesManagerContext } from "../context";
import { TabsItemFiles } from "../utils/enums/tabs";
import { useFilter } from "../../../hooks/filter";
import { formatFilterList, formatFilterMain } from "../pages/main/components/allFiles/constans/menu"
import { useGetData } from "../pages/main/components/allFiles/hooks/getData"
import { removeAllReference } from "../../../utils/methods/removedReference";
import { FilterProps } from "../../../hooks/filter/typing";
import { useGetDataList } from "../pages/main/components/userFiles/hooks/getDataList";
import { DownloadType } from "../../../hooks/download/useDownload";
import { filesManagerServiceFetch } from "../../../utils/constants/callService";

const FilesManagerProvider = ({ children }: { children: ReactElement }) => {

    const filterMainData = useGetData()
    const filterListData = useGetDataList()

    const externalValidation: FilterProps['externalValidation'] = ({
        name,
        value,
        body,
        setFilterData,
    }) => {
        let copyBody: Record<string, any> = removeAllReference(body)

        if (name === 'area') {
            const { area, department: departmentsData } = copyBody
            const newDepartments = departmentsData?.filter((e: any) =>
                area.find((e2: any) => e2.value == e.areaId)
            )


            let arrayChilds: any[] = []

            area?.forEach((e: any) => {
                const id = e.value
                const childs = filterMainData.departments.filter((child) => child.areaId == id)
                arrayChilds.push(...childs)
            })



            filterMainData.handleItemsByExternal({ name: 'department', value: arrayChilds })
            setFilterData((prev) => ({
                ...prev,
                department: newDepartments,
            }))

            copyBody = {
                ...copyBody,
                department: newDepartments,
            }
        }


        return copyBody
    }

    const externalValidationList: FilterProps['externalValidation'] = ({
        name,
        value,
        body,
        setFilterData,
    }) => {
        let copyBody: Record<string, any> = removeAllReference(body)

        if (name === 'area') {
            const { area, department: departmentsData } = copyBody
            const newDepartments = departmentsData?.filter((e: any) =>
                area.find((e2: any) => e2.value == e.areaId)
            )


            let arrayChilds: any[] = []

            area?.forEach((e: any) => {
                const id = e.value
                const childs = filterListData.departments.filter((child) => child.areaId == id)
                arrayChilds.push(...childs)
            })



            filterListData.handleItemsByExternal({ name: 'department', value: arrayChilds })
            setFilterData((prev) => ({
                ...prev,
                department: newDepartments,
            }))

            copyBody = {
                ...copyBody,
                department: newDepartments,
            }
        }

        return copyBody
    }

    const [tabValue, setTabValue] = useState(TabsItemFiles.ALL_FILES);
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const [notFileSelected, setNotFileSelected] = useState<number[]>([]);
    const [isChecked, setIsChecked] = useState(false)
    const filterFileMain = useFilter({ formatFilter: formatFilterMain, externalValidation })
    const filterFileList = useFilter({ formatFilter: formatFilterList, externalValidation: externalValidationList })

    const [isLoading, setIsLoading] = useState(false)
    const [typeDownload, setTypeDownload] = useState<DownloadType | undefined>()
    const [uuid, setUuid] = useState('')
    const getDetailInform = async ({ query, type }: { query?: string, type?: DownloadType }) => {
        if (!uuid) {
            const response = await filesManagerServiceFetch.getRegister({ type: type as DownloadType, query });
            if (response.uuid) {
                setUuid(response.uuid)
                setTypeDownload(type)
                setIsLoading(true)
            }
        } else {
            const response = await filesManagerServiceFetch.generateSummary(uuid);
            if (response.reportUrl) {
                setUuid('')
                fetch(response.reportUrl)
                    .then(res => res.blob())
                    .then(blob => {
                        let extension = '';

                        switch (typeDownload) {
                            case 'pdf':
                                extension = '.pdf';
                                break;
                            case 'excel':
                                extension = '.xlsx';
                                break;
                            case 'word':
                                extension = '.docx';
                                break;
                        }
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `Listado de archivos${extension}`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);

                    })
                    .catch(err => console.error('Error al descargar el archivo:', err))
                    .finally(() => {
                        setIsLoading(false);
                        //window.open(response?.reportUrl ?? '');
                        setTypeDownload(undefined)
                    });
            }
        }
    }



    const value = useMemo(() => ({
        tabValue,
        setTabValue,
        selectedIds,
        setSelectedIds,
        notFileSelected,
        setNotFileSelected,
        isChecked,
        setIsChecked,
        filterFileMain,
        filterMainData,
        filterFileList,
        filterListData,
        isLoading,
        uuid,
        getDetailInform,
        typeDownload
    }), [ typeDownload, isLoading, uuid,  getDetailInform, tabValue, selectedIds, notFileSelected, isChecked, filterFileMain, filterMainData, filterFileList, filterListData]);

    return (
        <FilesManagerContext.Provider value={value}>
            {children}
        </FilesManagerContext.Provider>
    );
};

export { FilesManagerProvider };